import { render, staticRenderFns } from "./comparison-table-package-new.vue?vue&type=template&id=26a82232&scoped=true&"
import script from "./comparison-table-package-new.vue?vue&type=script&lang=ts&"
export * from "./comparison-table-package-new.vue?vue&type=script&lang=ts&"
import style0 from "./comparison-table-package-new.vue?vue&type=style&index=0&id=26a82232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a82232",
  null
  
)

export default component.exports